module.exports = __webpack_public_path__ + "b5612cef9b2db82ff0b72810485e359a.pdf";